import { ui, select } from '@owenscorning/pcb.alpha';

import Modular from './Modular';

const Settings = {
  postalRequired: ui`Switch`({ label: 'Require Postal Code?', default: false }),
};

const Module = Modular('ModulePlayground', 'ModulePlayground', {
  displayName: 'Module Playground',
  usage: 'name',
  layout: { Header: ['Hero', 'StickyNav'] },
  list: UI => ({
    'layout/Header': Modular.Layout.List(UI, 'Header', ['StickyNav']),
    sections: ui`List`.of({ modules: Modular.Module.List(UI) })({
      title: 'details/name',
      singular: 'Section',
      actions: [
        {
          label: 'Settings',
          icon: 'cogs',
          onClick: Modular.Section,
        },
      ],
      startOpened: select`~lastOpenedSection`,
    }),
  }),
  settings: Settings,
});

Module.Settings = Settings;

export default Module;
